import React from 'react'
import className from 'classnames/bind'

import MyhouseCommonLayout from '../MyhouseCommonLayout'
import MyhouseCommonTitleLayout from '../MyhouseCommonTitleLayout'
import MyhouseCommonButton, { BUTTONTYPE } from '../MyhouseCommonButton'
import MyhouseCommonTooltipLayer from '../MyhouseCommonTooltipLayer'

import style from './MyhouseUnitLandPrice.module.scss'

import MyhousePrice from '@Components/atoms/MyhousePrice'
import { NCLICK } from '@Root/contants/lcs'
import { handleNclickMix } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  detailAddress?: any
  growthRatioYearly?: any
  basisDate?: any
  unitLandPriceMoreInfoHandler?: any
  landPrice?: any
  prevYear?: any
  tax?: any
  isTrendPriceAreaExist?: boolean
}

const MyhouseUnitLandPrice: React.FC<Props> = ({
  detailAddress,
  basisDate,
  unitLandPriceMoreInfoHandler,
  prevYear,
  landPrice,
  growthRatioYearly,
  tax,
  isTrendPriceAreaExist,
}: Props) => {
  return (
    <div id="myhouse_unit_land_price" className={cx(!isTrendPriceAreaExist ? 'article' : '')}>
      <MyhouseCommonLayout>
        <MyhouseCommonTitleLayout title="우리집 공시가격" description={`${basisDate}. 공시 기준일`}>
          <MyhouseCommonTooltipLayer styleTooltip={{ top: '24px' }} title={'공시가격'} nclickOpen={NCLICK.MY_HOUSE.UNIT_LAND_PRICE.TOOLTIP}>
            <div>
              본 공시가격은 공공데이터 포털에서 제공하고 있는 주택 공시가격정보를 기반으로 제공하고 있으며, 공공데이터 포털에서 제공하지 않는 일부 호수의 공시가격은 네이버페이
              부동산에도 제공되지 않습니다.
            </div>
            <br />
            <div>
              재산세: 매년 6월 1일을 기준으로 재산을 사실상 소유한 자에게 부과되며 1/2씩 7월과 9월에 고지됩니다. 도시지역분은 지역에 따라 부과되지 않을 수 있으며, 지역자원시설세는
              반영되지 않았습니다.
            </div>
            <br />
            <div>종합부동산세: 1세대 1주택을 기준으로 계산되었으며 고령자, 장기보유공제, 세부담상한초과세액공제는 반영되지 않았습니다.</div>
            <br />
            <div>본 공과금은 실제 적용되는 금액과 다를 수 있으므로 참고용으로 활용하시기 바랍니다.</div>
          </MyhouseCommonTooltipLayer>
        </MyhouseCommonTitleLayout>
        <MyhousePrice
          name={detailAddress}
          price={landPrice}
          priceList={
            growthRatioYearly != null
              ? [
                  {
                    title: `${prevYear}년 대비`,
                    text: `${growthRatioYearly}%`,
                    type: growthRatioYearly > 0 ? 'plus' : growthRatioYearly < 0 ? 'minus' : 'same',
                  },
                  { title: '보유세', text: `약 ${tax}` },
                ]
              : [{ title: '보유세', text: `약 ${tax}` }]
          }
        />
        <MyhouseCommonButton
          onClick={handleNclickMix(NCLICK.MY_HOUSE.UNIT_LAND_PRICE.MORE, unitLandPriceMoreInfoHandler)}
          buttonType={BUTTONTYPE.LINK_GRAY}
          buttonText={'공시가격 더보기'}
          icon
        />
      </MyhouseCommonLayout>
    </div>
  )
}

export default MyhouseUnitLandPrice
